import { APP_BASE_HREF } from '@angular/common';
import { ErrorHandler, NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { XSRFHeaderInterceptor } from './http-interceptors/xsrf-header-interceptor';
import { GlobalErrorInterceptor } from './error-interceptors/error-interceptor';
import { SortablejsModule } from 'nxt-sortablejs';
import { ToastrModule } from 'ngx-toastr';

//App Component
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

//Supporting multiple layout
import { LayoutModule } from './layout/layout.module';
import { NotificationPageComponent } from './core/components/notification-page/notification-page.component';
import { GlobalSpinnerComponent } from './core/components/global-spinner/global-spinner.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { DateDeserializationInterceptor } from './http-interceptors/date-interceptor';

@NgModule({
  declarations: [AppComponent, NotificationPageComponent, GlobalSpinnerComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ModalModule.forRoot(),
    AppRoutingModule,
    BsDatepickerModule.forRoot(),
    LayoutModule,
    SortablejsModule.forRoot({
      animation: 150,
    }),
    ToastrModule.forRoot({
      positionClass: 'toast-top-center',
      timeOut: 5000,
    }),
    ServiceWorkerModule.register('/scripts/ngsw-worker.js', {
      enabled: true,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerImmediately',
    }),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: XSRFHeaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: DateDeserializationInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorInterceptor },
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: 'Window', useValue: window },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
